import React, { Component } from "react";
import { Map, Marker, GoogleApiWrapper, InfoWindow } from "google-maps-react";
import MarkerInfoWindow from "./MarkerInfoWindow";
import { Tooltip } from "@material-ui/core";
import MapLegend from "./MapLegend";

const mapStyles = {
  width: "100%",
  height: "100%",
};
const initialCenter = {
  lat: 49.1951,
  lng: 16.6068,
}; //centered to Brno

const styles = require("./googleMapStyles.json");

export const city_proj_client_type = "město-projekt";
export const school_proj_client_type = "škola-projekt";
export const city_part_client_type = "město-rozpočet";
export const school_part_client_type = "škola-rozpočet";

export class MapContainer extends Component {
  state = {
    cities: [],
    selectedCity: null,
    activeMarker: null,
    showingInfoWindow: false,
  };

  render() {
    return (
      <React.Fragment>
        <MapLegend showProviderLegend={this.props.showProviderLegend} />
        <Map
          google={this.props.google}
          zoom={7}
          style={mapStyles}
          initialCenter={initialCenter}
          mapTypeControl={false}
          streetViewControl={false}
          fullscreenControl={false}
          zoomControl={true}
          styles={styles}
        >
          {this.displayMarkers()}
          {this.displayInfoWindow()}
        </Map>
      </React.Fragment>
    );
  }

  //onComponentUpdate - update state.places = props.places
  componentDidUpdate(prevProps) {
    if (this.props.cities !== prevProps.cities) {
      this.setState({
        cities: this.props.cities,
      });
      if (!this.props.cities.includes(this.state.selectedCity)) {
        this.setState({
          showingInfoWindow: false,
          selectedCity: null,
          activeMarker: null,
        });
      }
    }
  }

  onMarkerClick = (props, marker, e) =>
    this.setState({
      selectedCity: props.city,
      activeMarker: marker,
      showingInfoWindow: true,
    });

  onClose = () => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        selectedCity: null,
        activeMarker: null,
      });
    }
  };

  displayInfoWindow = () => {
    return (
      <InfoWindow
        marker={this.state.activeMarker}
        visible={this.state.showingInfoWindow}
        onClose={this.onClose}
      >
        {this.displayMarkerInfoWindow()}
      </InfoWindow>
    );
  };

  displayMarkerInfoWindow = () => {
    if (this.state.selectedCity === null) {
      console.log("no selected city to show");
      return <text>nothing to show</text>;
    }
    return <MarkerInfoWindow city={this.state.selectedCity} />;
  };

  selectIcon(city) {
    const client_type = city["client_type"];
    console.log(client_type);

    if (!this.cityIsProvidedByPart21(city)) {
      return "ostatni.png";
    }
    //FIXME: use correct icons
    if (client_type === city_proj_client_type) {
      return "mesta-projekt.png";
    } else if (client_type == city_part_client_type) {
      return "mesta-rozpocet.png";
    } else if (client_type === school_proj_client_type) {
      return "skoly-projekt.png";
    } else if(client_type === school_part_client_type) {
      return "skoly-rozpocet.png";
    } else {
      //unknown client type
      return;
    }
  }

  cityIsProvidedByPart21(city) {
    for (let index = 0; index < city.yearsArray.length; index++) {
      if (city.yearsArray[index].provider === "participace21") {
        return true;
      }
    }
    return false;
  }

  displayMarkers = () => {
    return this.state.cities.map((city, index) => {
      console.log("marker render", city.name);
      return (
        <Tooltip title={city.city_name} key={index}>
          <Marker
            key={index}
            id={index}
            position={{
              lat: city.location.latitude,
              lng: city.location.longitude,
            }}
            onClick={this.onMarkerClick}
            city={city}
            icon={this.selectIcon(city)}
          />
        </Tooltip>
      );
    });
  };
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyCIZ9sRJiIvhnBTEIhxKSDNChHSjka0PLY",
})(MapContainer);
